import Hidden from "@material-ui/core/Hidden";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import headerStyle from "assets/jss/material-kit-pro-react/components/headerStyle.jsx";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import HeaderDesktop from "components/Header/HeaderDesktop";
import HeaderMobile from "components/Header/HeaderMobile";
import { useIsMobile } from "hooks/useMedia";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const styles = (theme) => ({
  ...headerStyle(theme),
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  subMenus: {
    cursor: 'pointer',
    marginRight: 20,
    color: 'white',
    fontWeight: 400,
    textTransform: 'uppercase',
    "&:hover": {
      borderBottom: '2px solid'
    },
    borderBottom: '2px solid transparent',
    fontSize: '1.2em'
  },

  headerContainer: {
    position: 'fixed',
    left: 0,
    right: 0,
    zIndex: 1200,
  },
  header: {
    height: '5rem'
  },

  input: {
    background: 'white',

  },
})
function Header(props) {
  const { classes, ...rest } = props;
  const isMobile = useIsMobile()
  return (
    <div className={classes.headerContainer}>
      {!isMobile && <HeaderDesktop {...rest} />}
      {isMobile && <HeaderMobile {...rest} />}
    </div>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),

  brand: PropTypes.node,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // this.props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // this.props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};


export default withStyles(styles, { withTheme: true })(Header)